/**
 * 설정 저장소 (FR-016/017) — UI 패널 없이 상태만 보관.
 * 음향 크기(0.0–1.0, 0=음소거)만 조절 가능. 화면 흔들림 강도는 저장된 현재값으로 고정.
 * settings:changed 발행, localStorage 영속.
 */
import type { EventBus } from '../core/EventBus';
import { loadSettings, saveSettings } from '../storage/records';
import type { Settings as SettingsData } from '../core/types';

export class Settings {
  private data: SettingsData;

  constructor(private bus: EventBus) {
    this.data = loadSettings();
    // 초기 상태 반영(저장된 음향 크기/흔들림 값을 시스템에 전파).
    this.emit();
  }

  /** 음향 크기 설정(0.0–1.0). 0이면 음소거. */
  setVolume(v: number): void {
    this.data.volume = Math.min(1, Math.max(0, v));
    saveSettings(this.data);
    this.emit();
  }

  get volume(): number {
    return this.data.volume;
  }

  private emit(): void {
    this.bus.emit('settings:changed', {
      // 화면 흔들림은 저장된 현재값으로 고정(사용자가 바꾸지 않음).
      shakeIntensity: this.data.shakeIntensity,
      volume: this.data.volume,
    });
  }
}
